import dayjs from "dayjs";
import isToday from "dayjs/plugin/isToday";

dayjs.extend(isToday);

export function GetNextWeek(dateObj) {
  return dayjs(dateObj).add(1, "w");
}

export function GetPreviousWeek(dateObj) {
  return dayjs(dateObj).subtract(1, "w");
}

export function GetDayName(date) {
  const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

  return days[date.getDay()];
}

export function GetDates(startDate, stopDate) {
  Date.prototype.addDays = function (days) {
    const date = new Date(this.valueOf());
    date.setDate(date.getDate() + days);
    return date;
  };
  const dateArray = new Array();
  let currentDate = startDate;
  while (currentDate <= stopDate) {
    dateArray.push(new Date(currentDate));
    currentDate = currentDate.addDays(1);
  }
  return dateArray;
}

export function GetStartingDates(date, premium = true) {
  return premium
    ? GetDates(dayjs(date).subtract(180, "d")["$d"], dayjs(date).add(60, "d")["$d"])
    : GetDates(dayjs(date).subtract(7, "d")["$d"], dayjs(date).add(7, "d")["$d"]);
}

export function CheckIsToday(dateObj) {
  return dayjs(dateObj).isToday();
}

export function GetMonthIndex(monthString = "") {
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  return months.indexOf(monthString);
}
